import React, { useEffect, useRef, useState } from "react";
import { Image } from 'primereact/image';
import { useSelector } from 'react-redux/es/exports';

const GallerySection11 = ({ pageName }) => {
  const data = useSelector(state => state.cms.allSections[pageName]);
  function getImage(image) {
    if (image && image.includes('blob:')) {
      return image;
    } else {
      return process.env.REACT_APP_STORAGE_URL + image;
    }
  }

   //section color start
   const [fileName, setFileName] = useState("");
   const [thisComponent, setThisComponent] = useState({});
   const sectionColor = useSelector((state) => state.cms.sectionColor[pageName]);
   const selectedSection = useSelector((state) => state.cms.sectionNames);
   //sectioncolor end
   //sectioncolor start
   useEffect(() => {
     const name = new URL(import.meta.url);
     const filename = name.pathname.split("/").pop();
     console.log(filename);
     const componentName = filename.split(".")[0];
     setFileName(componentName);
 
     for (let i = 0; i < selectedSection[pageName].length; i++) {
       if (
         selectedSection[pageName][i].path.includes(componentName.split(".")[0])
       ) {
         setThisComponent(selectedSection[pageName][i]);
       }
     }
   }, [selectedSection]);
   //sectioncolor end

  return (
    <div className="lg:py-12 md:py-10 py-8" style={{ background: thisComponent.sectionColor }}>
      <div className="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-1">
        <div className="relative">
          <div id="9377051092" className="dynamicStyle2">
            <Image
              src={data ? getImage(data['9377051092']) : ''}
              fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
              alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="5470467171"
              className="card_title clr-fff dynamicStyle">
                {data ? data['5470467171'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
        <div className="relative lg:col-span-2 md:col-span-2 col-span-1">
          <div id="8563568914" className="dynamicStyle2">
            <Image
              src={data ? getImage(data['8563568914']) : ''}
              fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
              alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="0086419568"
              className="card_title clr-fff dynamicStyle">
                {data ? data['0086419568'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
        <div className="relative">
          <div id="1357457929" className="dynamicStyle2">
            <Image
              src={data ? getImage(data['1357457929']) : ''}
              fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
              alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="9296387107"
              className="card_title clr-fff dynamicStyle">
              {data ? data['9296387107'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
        <div className="relative">
          <div  id="7885148815" className="dynamicStyle2">
            <Image
              src={data ? getImage(data['7885148815']) : ''}
              fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
              alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="1927896925"
              className="card_title clr-fff dynamicStyle">
                {data ? data['1927896925'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
        <div className="relative">
          <div id="3109756882" className="dynamicStyle2">
            <Image
              src={data ? getImage(data['3109756882']) : ''}
              fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
              alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="1599860975"
              className="card_title clr-fff dynamicStyle">
                {data ? data['1599860975'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
        <div className="relative lg:col-span-2 md:col-span-2 col-span-1">
          <div id="5525702970" className="dynamicStyle2">
            <Image
               src={data ? getImage(data['5525702970']) : ''}
               fallbackSrc={`${process.env.REACT_APP_STORAGE_URL}Quarkly/default/1285952.jpg`}
               alt="img"
              imageClassName="lg:h-72 md:h-52 h-52 w-full object-cover"
            />
          </div>
          <div className="absolute top-0 left-0 lg:h-72 md:h-52 h-52 w-full gallery11-text flex items-center justify-center">
            <div className="bordb lg:w-max md:w-max md-max-w sm-max-w px-4 py-2 lg:px-6 lg:py-2 md:px-5 md:py-2">
              <h3 id="5138624571"
              className="card_title clr-fff dynamicStyle">
                {data ? data['5138624571'] : 'Lorem Ipsum'}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GallerySection11;
